<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">
        <chemical-latex content="^{131}I" />
        is used to treat prostate cancer. It has a half-life of
        <stemble-latex content="$8.0197\,\text{days.}$" />
        What percent of the original
        <chemical-latex content="^{131}I" />
        remains in the human body
        <number-value :value="time" unit="\text{days}" />
        following the treatment?
      </p>

      <calculation-input
        v-model="inputs.input1"
        prepend-text="$\%\,\text{remaining:}$ "
        append-text="$\%$"
        :disabled="!allowEditing"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '../inputs/CalculationInput';
import NumberValue from '../NumberValue';
import StembleLatex from '@/tasks/components/StembleLatex';
import ChemicalLatex from '@/tasks/components/displayers/ChemicalLatex.vue';

export default {
  name: 'ChemCPP1220S4Q7',
  components: {
    ChemicalLatex,
    CalculationInput,
    NumberValue,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        input1: null,
      },
    };
  },
  computed: {
    time() {
      return this.taskState.getValueBySymbol('time').content;
    },
  },
};
</script>
